/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Label
 */
export interface Label {
  /**
   *
   * @type {string}
   * @memberof Label
   */
  labelId?: string;
  /**
   *
   * @type {string}
   * @memberof Label
   */
  labelGroupId?: string;
  /**
   *
   * @type {string}
   * @memberof Label
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof Label
   */
  description?: string;
}

/**
 * Check if a given object implements the Label interface.
 */
export function instanceOfLabel(value: object): value is Label {
  return true;
}

export function LabelFromJSON(json: any): Label {
  return LabelFromJSONTyped(json, false);
}

export function LabelFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Label {
  if (json == null) {
    return json;
  }
  return {
    labelId: json["labelId"] == null ? undefined : json["labelId"],
    labelGroupId:
      json["labelGroupId"] == null ? undefined : json["labelGroupId"],
    title: json["title"] == null ? undefined : json["title"],
    description: json["description"] == null ? undefined : json["description"],
  };
}

export function LabelToJSON(json: any): Label {
  return LabelToJSONTyped(json, false);
}

export function LabelToJSONTyped(
  value?: Label | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    labelId: value["labelId"],
    labelGroupId: value["labelGroupId"],
    title: value["title"],
    description: value["description"],
  };
}
